/**
 * Redirects legacy sale collection URLs to the localized sale collection path.
 * Country code is injected via the script tag data-country attribute from Liquid.
 */
(function () {
  const script = document.currentScript;
  const country = script?.dataset?.country;
  if (!country) return;

  const path = window.location.pathname;
  const match = path.match(/^\/collections\/([^/]+)-sale-([^/]+)(?:\/|$)/);
  if (!match) return;

  const gender = match[1];
  const industry = match[2];
  const target = `/collections/sale-${country}-${gender}-${industry}${window.location.search}`;

  if (`${window.location.pathname}${window.location.search}` !== target) {
    window.location.replace(target);
  }
})();
